export enum ItemThumbnailSize {
  Small = 'thumb70x100',
  Medium = 'thumb150x210',
  Large = 'thumb310x430',
  XLarge = 'thumb364x428',
  X2Large = 'thumb624x428',
}

export enum AdditionalTransactionAction {
  MarkAsSold = 'mark_as_sold',
  MarkAsReceived = 'mark_as_received',
  CanMarkAsReceived = 'can_mark_as_received',
  Bundle = 'bundle',
  UsePayments = 'use_payments',
  DeleteConversation = 'delete_thread',
  Cancel = 'cancel',
  ConfirmShipmentInstructions = 'confirm_shipment_instructions',
  ExtendShippingDeadline = 'extend_shipping_deadline',
  ChangeDeliveryOption = 'change_delivery_option',
}

export enum OfferRequestStatus {
  Pending = 10,
  Accepted = 20,
  Rejected = 30,
  Cancelled = 40,
}

export enum ConversationMessageType {
  ActionMessage = 'action_message',
  StatusMessage = 'status_message',
  Message = 'message',
  PortalMessage = 'portal_message',
  OfferMessage = 'offer_message',
  OfferRequestMessage = 'offer_request_message',
  ReportSuggestion = 'report_suggestion',
  AutoReplyFeedbackRequestMessage = 'auto_reply_feedback_request_message',
  ChatbotFeedbackRequestMessage = 'chatbot_feedback_request_message',
  ConversationalChatbotFeedbackRequestMessage = 'conversational_chatbot_feedback_request_message',
}

export enum ModeratedItemAvailabilityStatus {
  Visible = 0,
  Hidden = 1,
  Deleted = 2,
  Expired = 3,
}

export enum TransactionSide {
  Buyer = 'buyer',
  Seller = 'seller',
}

export enum TransactionStatus {
  DebitProcessed = 230,
  StatusNew = 1,
  StatusEstimated = 100,
  StatusDebitFailed = 220,
}

export enum ApplicableTransactionAction {
  Offer = 'offer',
  Buy = 'buy',
  RequestOffer = 'request_offer',
  Transfer = 'transfer',
  Reserve = 'reserve',
  WaitingForShipment = 'waiting_for_shipment',
  LeaveFeedback = 'feedback',
}

export enum ShipmentStatus {
  New = 1,
  Estimated = 100,
  InstructionsConfirmed = 150,
  LabelProcessing = 200,
  LabelFailed = 210,
  LabelProcessed = 220,
  LabelSent = 230,
  TrackingPending = 250,
  Shipped = 300,
  HeldAtPostOffice = 310,
  LostParcel = 350,
  Delivered = 400,
  CancelDone = 500,
  ReturnToSender = 600,
  ReturnToSenderAvailableForPickup = 610,
  CancelFailed = 620,
  ReturnToSenderDelivered = 625,
  ReturnToSenderCompleted = 630,
  ShippedToFacility = 700,
  ArrivedAtFacility = 710,
  VerificationSuccessful = 720,
  VerificationFailed = 730,
  ShippedFromFacility = 740,
}
